import React from 'react';
import { Link } from 'react-router-dom';
import { ZapIcon, GaugeIcon, UsersIcon, BarChart3Icon, ActivityIcon, ArrowRightIcon, LayoutDashboardIcon } from 'lucide-react';
import { useMunicipality } from '../hooks/useMunicipality';
export function Launch() {
  const {
    selected: municipality
  } = useMunicipality();
  const modules = [{
    title: 'Vending',
    icon: ZapIcon,
    path: '/vending',
    description: 'Prepaid electricity token sales and payment processing'
  }, {
    title: 'Smart Meters',
    icon: GaugeIcon,
    path: '/meters',
    description: 'Monitor residential and large power user meters'
  }, {
    title: 'Vendors',
    icon: UsersIcon,
    path: '/vendors',
    description: 'Manage vendor network, commissions, and sales'
  }, {
    title: 'Revenue',
    icon: BarChart3Icon,
    path: '/prepaid-revenue',
    description: 'Track revenue, tariffs, and billing integrations'
  }, {
    title: 'Grid Balance',
    icon: ActivityIcon,
    path: '/substation-monitoring',
    description: 'Substation monitoring, outage detection, and loss analytics'
  }];
  return <div className="fixed inset-0 z-50 bg-gray-50 overflow-y-auto flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8 animate-in fade-in duration-500" data-id="element-1277">
      {/* Header / Logo */}
      <div className="flex flex-col items-center mb-12 text-center" data-id="element-1278">
        <div className="bg-white p-4 rounded-none mb-6 border border-gray-100" data-id="element-1279">
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/s5dgpz2pomohbgjmvchnas/19620cb4-f500-4d30-868d-0c11080a1184/mavis_letters_logo_2.svg" alt="MAVIS Logo" className="h-48 w-auto object-contain" data-id="element-1280" />

        </div>
        <h1 className="text-4xl font-bold text-gray-900 tracking-tight mb-2" data-id="element-1281">
          MAVIS
        </h1>
        <p className="text-lg text-gray-500 max-w-xl font-[500]" data-id="element-1282">
          Welcome to Municipal Advanced Vending Infrastructure System (MAVIS)
        </p>
        <p data-id="element-1283">
          A municipal metering management infrastructure platform that helps
          municipalities recover lost electricity revenue, improve cashflow, and
          modernize their power networks.
        </p>
      </div>

      {/* Module Cards Grid */}
      <div className="w-full max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-1284">
        {modules.map((mod, index) => {
        const Icon = mod.icon;
        return <Link key={index} to={mod.path} className="group flex flex-col bg-white border border-gray-200 rounded-none p-6 shadow-sm hover:shadow-lg transition-all duration-300 relative overflow-hidden" style={{
          borderBottomWidth: '4px',
          borderBottomColor: 'transparent'
        }} onMouseEnter={e => {
          e.currentTarget.style.borderBottomColor = municipality.accentColor;
        }} onMouseLeave={e => {
          e.currentTarget.style.borderBottomColor = 'transparent';
        }} data-id="element-1285">

              <div className="flex items-start justify-between mb-4" data-id="element-1286">
                <div className="w-12 h-12 flex items-center justify-center rounded-none shadow-sm transition-transform duration-300 group-hover:scale-110" style={{
              backgroundColor: municipality.accentColor
            }} data-id="element-1287">

                  <Icon className="w-6 h-6 text-white" data-id="element-1288" />
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-50 opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-4 group-hover:translate-x-0" data-id="element-1289">
                  <ArrowRightIcon className="w-4 h-4" style={{
                color: municipality.accentColor
              }} data-id="element-1290" />

                </div>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-gray-700 transition-colors" data-id="element-1291">
                {mod.title}
              </h2>
              <p className="text-sm text-gray-500 leading-relaxed flex-1" data-id="element-1292">
                {mod.description}
              </p>
            </Link>;
      })}
      </div>

      {/* Dashboard Link */}
      <div className="mb-16" data-id="element-1293">
        <Link to="/dashboard" className="flex items-center gap-2 px-6 py-3 bg-white border border-gray-200 text-gray-700 font-medium rounded-none shadow-sm hover:bg-gray-50 hover:text-gray-900 transition-colors group" data-id="element-1294">

          <LayoutDashboardIcon className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" data-id="element-1295" />
          Go to Dashboard Overview
        </Link>
      </div>

      {/* Footer */}
      <div className="mt-auto text-center pb-8" data-id="element-1296">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest" data-id="element-1297">
          Municipal Advanced Vending Infrastructure System (MAVIS)
        </p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-1298">
          &copy; {new Date().getFullYear()} Sondlane Telecoms (PTY) Ltd. All
          rights reserved.
        </p>
      </div>
    </div>;
}